

<template>
	<div class="intro-animation">
		<!-- Alles im CANVAS von Adobe Animate! -->
	</div>
</template>

<script>

import { store } from '@/store'
import { mapState } from 'vuex'

import { Log } from '@/services/log.service'
import { KombiRepository } from '@/repositories/KombiRepository'
import { gsap, TweenMax, TimelineMax, Power2, Power3, Power4, Linear } from 'gsap';

export default {
	store,
	props: ['visible'],
	data: () => {
		return {
			initialized: false,
			stage_mc: false,
			main_mc: false,
			elementCnt: 0,
			intro_mc: false,
			isPlaying: false,
			isPaused: false,
			ivs: [],
		}
	},

	watch: {
		visible( val ) {
			this.toggleAnimation( val );
		}
	},

	computed: {
		...mapState('settings', ['presets']),
		...mapState('globals', ['animation']),
		...mapState('configurator', ['intro']),
		stageHeight() {
			return this.animation.canvas.height * (1/this.animation.canvas.width * this.animation.width);
		},
	},

	mounted() {
		this.elementCnt = Math.floor(Math.random() * Object.keys(this.intro).length);
		this.intro_mc = new createjs.Container();
		this.animation.stage.addChild( this.intro_mc );
		this.intro_mc.x = 0;
		this.intro_mc.y = 0;
		this.toggleAnimation( this.visible );

		window.addEventListener('blur', this.onBlurWindow.bind(this) );
		window.addEventListener('focus', this.onFocusWindow.bind(this) );
	},

	beforeDestroyed() {
		window.removeEventListener('blur', this.onBlurWindow.bind(this) );
		window.removeEventListener('focus', this.onFocusWindow.bind(this) );
	},

	methods: {

		/**
		 * 	Fenster / Tab wird fokussiert
		 */
		onBlurWindow() {
			this.isPaused = true;
		},
		onFocusWindow() {
			this.isPaused = false;
		},


		/**
		 * 	Animation starten / stoppen
		 * 
		 */
		toggleAnimation( val ) {
			this.isPlaying = val;
			this.ivs.forEach((n) => {
				clearInterval( n );
			});

			if (val) {
				for (var i = 0; i < 3; i++) {
					setTimeout(() => {
						var iv = setInterval( this.addElement.bind(this), 2000 );
						this.ivs.push( iv );
					}, i * 2000);
				}
				TweenMax.to( this.intro_mc, 1, {delay:2, alpha:1});
			} else {
				TweenMax.to( this.intro_mc, 1, {alpha:0});
			}
		},

		/**
		 * 	CreateJS-Element als Bitmap cachen und nach
		 * 	bestimmter Zeit wieder freigeben.
		 * 	Performance-Tweek.
		 * 
		 */
		bitmapCacheTimer( dur, el ) {
			if (!el) el = this.main_mc;
			el.cache(-400, -400, 800, 800, 3);
			setTimeout(() => {
				el.uncache();
			}, dur * 1000);
		},

		/**
		 * 	Ein Element hinzufügen und langsam ein/ausfaden während Zoom.
		 * 
		 */
		addElement () {

			if (!this.isPlaying || this.isPaused) return;

			var keys = Object.keys(this.intro);
			this.elementCnt = (this.elementCnt+1) % keys.length;
			var key = keys[this.elementCnt];
			var obj = this.intro[key];
			if (!this.animation.lib[obj.lib]) {
				return Log.ERROR('IntroAnimation->addElement()', `${key} nicht in der Animate-Bibliothek gefunden`, this.animation.lib);
			}

			var el = new this.animation.lib[obj.lib]();
			this.intro_mc.addChild( el );
			
			var tl = new TimelineMax({
				onComplete: this.removeElements, 
				onCompleteParams: [{remove:[el], mc:this.intro_mc}]
			});

			Object.assign(el, {
				alpha: 0, 
				y: this.stageHeight / 2 + (-200 + Math.random()*400),
				x: this.animation.width / 2 + (-400 + Math.random()*800),
				scale: 3
			});

			tl.to(el, 1, {alpha: 0.2}).to(el, 1, {alpha: 0}, 3);
			tl.to(el, 4, {scale: 4, ease:Linear.easeNone}, 0 );
		},

		removeElements( obj ) {
			obj.mc.removeChild( ...obj.remove );
		}

	}

}
</script>

<style scoped lang="scss">
	
</style>



// WEBPACK FOOTER //
// src/components/IntroAnimation.vue